export const SalesV1PermissionKeys = Object.freeze({
  LIST: {
    VIEW: 'salesV1.list-view',
    UPDATE: 'salesV1.list-update',
    DELETE: 'salesV1.list-delete',
  },
});
